/**
 * DiagnosticsConfig
 *
 * Helper functions (`thresholdColor`, `pingColor`) for the diagnostic
 * UI. Threshold values have moved to `src/shared/config/diagnostics.config.ts`
 * (defaults+dev-override pattern per `docs/plans/2026-04-25-CONFIG-MIGRATION.md`).
 *
 * The legacy `DIAGNOSTICS_THRESHOLDS` ALL_CAPS const is re-exported from
 * the new typed config so existing consumers (NetworkStatsView,
 * MultiplayerDiagnosticsPanel) keep working without edits.
 */

import { DIAGNOSTICS } from '../config/diagnostics.config';

/** @deprecated Import `DIAGNOSTICS` from `src/shared/config/diagnostics.config`. */
export const DIAGNOSTICS_THRESHOLDS = {
  CORRECTIONS: { OK: DIAGNOSTICS.corrections.ok, WARN: DIAGNOSTICS.corrections.warn },
  ERROR_OFFSET: { OK: DIAGNOSTICS.errorOffset.ok, WARN: DIAGNOSTICS.errorOffset.warn },
  SCHEMA_RENDER_DIST: { OK: DIAGNOSTICS.schemaRenderDist.ok, WARN: DIAGNOSTICS.schemaRenderDist.warn },
  PING: { OK: DIAGNOSTICS.pingMs.ok, WARN: DIAGNOSTICS.pingMs.warn },
  PENDING_INPUTS: { OK: DIAGNOSTICS.pendingInputs.ok, WARN: DIAGNOSTICS.pendingInputs.warn },
};

/**
 * Returns a CSS color based on threshold comparison.
 * value <= ok → green, value <= warn → orange, else → red
 */
export function thresholdColor(value: number, thresholds: { OK: number; WARN: number }): string {
  if (value <= thresholds.OK) return '#2ecc71';
  if (value <= thresholds.WARN) return '#f39c12';
  return '#e74c3c';
}

/**
 * Ping-specific color (null = unknown/gray).
 */
export function pingColor(ping: number | null): string {
  if (ping == null) return '#9db0d7';
  return thresholdColor(ping, DIAGNOSTICS_THRESHOLDS.PING);
}
